import Vue from "vue"
import Router from "vue-router"
import Contacts from "./views/Contacts.vue"
import DetectMobile from "@/views/DetectMobile";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: { name: 'contacts', params: { type: 'default'}}
    },
    {
      path: "/mobile/:mobile",
      name: "mobile",
      component: DetectMobile,
    },
    {
      path: "/contacts/:type",
      name: "contacts",
      component: Contacts,
    },
    {
      path: "/add",
      name: "add",
      component: () => import(/* webpackMode: "eager" */'@/views/AddUser')
    },
    {
      path: "/me",
      name: "me",
      component: () => import(/* webpackMode: "eager" */'@/views/Profile')
    },
    {
      path: "/login",
      name: "login",
      component: () => import(/* webpackMode: "eager" */'@/views/Login')
    },
    {
      path: "/message/:uid",
      name: "message",
      component: () => import(/* webpackMode: "eager" */'@/views/Messages')
    },
    {
      path: "/export/:uid",
      name: "export",
      component: () => import(/* webpackMode: "eager" */'@/views/Export')
    },
    {
      path: '/refresh',
      component: () => import(/* webpackMode: "eager" */'@/components/Refresh')
    },
    {
      path: '/jsbridge',
      name: "jsbridge",
      component: () => import(/* webpackMode: "eager" */'@/views/JSbridge')
    }
  ]
})
